import { ZButton } from "@/shared/components/button";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/react";

interface DeleteQuestionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const DeleteQuestionModal = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
}: DeleteQuestionModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalContent>
        <ModalHeader className="self-center">
          <div className="flex flex-col items-center justify-center gap-2">
            <p className="text-[18px] font-semibold">
              Are you sure you want to delete this question?
            </p>
          </div>
        </ModalHeader>
        <ModalBody className="self-center items-center">
          <p className="text-[#777780] text-tiny text-center">
            This action cannot be undone. The question will be
          </p>
          <p className="text-[#777780] text-tiny text-center">
            permanently removed from the questionnaire.
          </p>
        </ModalBody>
        <ModalFooter className="border-t">
          <ZButton
            color="primary"
            className="w-full"
            variant="bordered"
            onClick={onClose}
            isDisabled={loading}
          >
            Cancel
          </ZButton>

          <ZButton
            color="danger"
            className="w-full"
            onClick={onConfirm}
            isLoading={loading}
          >
            Yes, Delete Question
          </ZButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteQuestionModal;
